//Episerver library
import Start from '../EpiServer.Spa.Core/InitBrowser';
import 'regenerator-runtime/runtime';

//Application
import config from 'app/Config';
import 'app/styles.scss';
import './utilities/globalExceptionHandler';

Start(config);
